export const gtmPushEvent = (data) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
};



// WEBPACK FOOTER //
// ./src/utils/gtmPushEvent.js